import React from 'react';
import { AlertCircle, Clock, DollarSign, FileText, MapPin } from 'lucide-react';

const StudioRules = () => {
  const rules = [
    { icon: DollarSign, text: "Deposit required to confirm session" },
    { icon: DollarSign, text: "Balance due upon arrival or full payment accepted online" },
    { icon: Clock, text: "10-minute grace period" },
    { icon: AlertCircle, text: "No call / no show = deposit forfeited" },
    { icon: Clock, text: "24-hour notice to reschedule" },
    { icon: AlertCircle, text: "Maximum 2 reschedules per booking" },
    { icon: AlertCircle, text: "Same-day cancellations lose deposit" },
    { icon: FileText, text: "Recording files delivered within 24 hours" },
    { icon: FileText, text: "Bring beats, lyrics, and files ready" },
    { icon: MapPin, text: "Respect the space and equipment" }
  ];

  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Studio <span className="bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">Rules & Policies</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Please review our policies to ensure a smooth session experience
          </p>
        </div>

        {/* Rules Grid */}
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-4">
            {rules.map((rule, index) => {
              const Icon = rule.icon;
              return (
                <div
                  key={index}
                  className="flex items-start space-x-3 bg-gradient-to-br from-purple-900/20 to-blue-900/20 backdrop-blur-sm border border-purple-500/20 rounded-lg p-4 hover:border-purple-500/50 transition-all"
                >
                  <Icon size={20} className="text-purple-400 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-300">{rule.text}</span>
                </div>
              );
            })}
          </div>

          {/* Smoking Allowed Highlight */}
          <div className="mt-8 text-center">
            <div className="inline-flex items-center space-x-2 bg-green-900/20 backdrop-blur-sm border border-green-500/30 rounded-full px-6 py-3">
              <span className="text-green-400 text-2xl">✓</span>
              <span className="text-gray-300 font-medium">Smoking Allowed</span>
            </div>
          </div>

          {/* Location Notice */}
          <div className="mt-8 bg-gradient-to-br from-purple-900/20 to-blue-900/20 backdrop-blur-sm border border-purple-500/20 rounded-xl p-6 text-center">
            <MapPin size={24} className="text-purple-400 mx-auto mb-3" />
            <h3 className="text-white font-semibold mb-2">Studio Location</h3>
            <p className="text-gray-400">
              High Quality Studios, Brooklyn, NY
            </p>
            <p className="text-gray-500 text-sm mt-2">
              Full address sent automatically after booking confirmation
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StudioRules;
